/**
 *  Copyright (c) 2021-present The TVM Engineering Authors.
 *
 */

import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { Paper, Button, Typography } from "@mui/material";
import sectionStyles from "../../theme/sectionStyles";

const useStyles = makeStyles(sectionStyles);

interface Props {
  actions: Array<Object>;
  fixedHeight: number;
  titleIcon: string;
  title: string;
  tip: string;
  description: string;
  description1: string;
  description2: string;
  description3: string;
  description4: string;
  titleStyle: Object;
  customStyle: Object;
  children: Object;
}

const Section = React.memo((props: Props) => {
  const { actions, title, description, tip, children, titleIcon, titleStyle, customStyle } = props;
  const [overrideTitleStyle] = useState(titleStyle);
  const [overridePaperStyle] = useState(customStyle);
  const classes = useStyles();

  return (
    <Paper className={overridePaperStyle || classes.root} elevation={3}>
      {(title || description || tip) && (
        <div className={classes.contentHeader && "display: none"}>
          {title && (
            <Typography component="h2" className={overrideTitleStyle || classes.title}>
              {titleIcon && titleIcon} {title}
            </Typography>
          )}
          {description && (
            <Typography component="p" className={classes.description}>
              {description}
            </Typography>
          )}
          {props.description1 && (
            <Typography component="p" className={classes.description}>
              {props.description1}
            </Typography>
          )}
          {props.description2 && (
            <Typography component="p" className={classes.description}>
              {props.description2}
            </Typography>
          )}
          {props.description3 && (
            <Typography component="p" className={classes.description}>
              {props.description3}
            </Typography>
          )}
          {props.description4 && (
            <Typography component="p" className={classes.description}>
              {props.description4}
            </Typography>
          )}
          {tip && (
            <Typography component="p" className={classes.description}>
              {tip}
            </Typography>
          )}
        </div>
      )}

      {actions && actions.length > 0 && (
        <div className={classes.actionHeader}>
          {actions.map((action) => (
            <Button
              disabled={action.isEdit ? action.disableConfirmButton : false}
              aria-label={action.label}
              color="primary"
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}

      <div>{children}</div>
    </Paper>
  );
});

export default Section;
